import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useSettings } from '../../../contexts/SettingsContext';
import apiClient from '../../../api/apiClient';
import RuntimeControls from './RuntimeControls';
import EnvironmentInfo from './EnvironmentInfo';

const SystemConfigurationTab = () => {
    const { settings, updateSetting, refreshSettings } = useSettings();
    const [environmentData, setEnvironmentData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch environment status data
    const fetchEnvironmentData = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await apiClient.get('/api/v1/system/status');
            setEnvironmentData(response.data);
        } catch (err) {
            console.error('Failed to fetch environment data:', err);
            setError('Failed to load environment information');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEnvironmentData();
    }, []);


    // Listen for global refresh events
    useEffect(() => {
        const handleGlobalRefresh = () => {
            fetchEnvironmentData();
        };

        window.addEventListener('globalRefresh', handleGlobalRefresh);
        return () => window.removeEventListener('globalRefresh', handleGlobalRefresh);
    }, []);

    if (loading) {
        return (
            <div className="flex flex-col gap-4 w-full">
                <div className="flex flex-row justify-between items-center">
                    <h3 className="text-xl flex flex-row gap-2 items-center">
                        <Icon icon='mdi:cog' className="text-xl text-primary" />
                        System Configuration
                    </h3>
                </div>
                <div className="flex items-center justify-center p-8">
                    <div className="text-font-secondary">Loading system configuration...</div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-3 w-full">
            <div className="flex flex-row justify-between items-center">
                <h3 className="subheader-textbox gap-1">
                    {/* <Icon icon='mdi:cog' className="text-xl text-primary" /> */}
                    System Configuration
                </h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <RuntimeControls />
                <EnvironmentInfo 
                    environmentData={environmentData}
                    loading={loading}
                    error={error}
                />
            </div>
        </div>
    );
};

export default SystemConfigurationTab;
